import React from "react";
import { Calculator, BellRing, ThumbsUp } from "lucide-react";

const steps = [
  { icon: Calculator, title: "Bereken uw prijs", text: "Vul de calculator in of bel ons. U ziet direct een eerlijke prijsindicatie." },
  { icon: BellRing, title: "Wij plannen in", text: "U ontvangt minimaal 24 uur vooraf bericht via e-mail of WhatsApp. Niet thuis? Geen probleem." },
  { icon: ThumbsUp, title: "Klaar & tevreden", text: "Vakkundig uitgevoerd, netjes achtergelaten. U betaalt eenvoudig achteraf per factuur." },
];

const HowItWorks = () => (
  <section className="py-20 bg-gradient-to-br from-slate-50 to-sky-50" aria-labelledby="howitworks-heading">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 id="howitworks-heading" className="text-3xl sm:text-4xl font-bold text-slate-800 mb-12 text-center">
        Zo werkt het
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {steps.map(({ icon: Icon, title, text }, i) => (
          <div key={title} className="relative bg-white rounded-3xl p-8 shadow-lg">
            <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-sky-500 to-teal-500 rounded-2xl flex items-center justify-center text-white font-bold text-lg shadow-lg">
              {i + 1}
            </div>
            <div className="w-14 h-14 bg-gradient-to-br from-sky-100 to-teal-100 rounded-2xl flex items-center justify-center mb-5">
              <Icon className="w-7 h-7 text-sky-600" />
            </div>
            <h3 className="text-xl font-bold text-slate-800 mb-2">{title}</h3>
            <p className="text-slate-600 leading-relaxed">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
